import { render, staticRenderFns } from "./PreviewPost.vue?vue&type=template&id=cafbc80a&scoped=true"
import script from "./PreviewPost.vue?vue&type=script&lang=js"
export * from "./PreviewPost.vue?vue&type=script&lang=js"
import style0 from "./PreviewPost.vue?vue&type=style&index=0&id=cafbc80a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafbc80a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cafbc80a')) {
      api.createRecord('cafbc80a', component.options)
    } else {
      api.reload('cafbc80a', component.options)
    }
    module.hot.accept("./PreviewPost.vue?vue&type=template&id=cafbc80a&scoped=true", function () {
      api.rerender('cafbc80a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/PreviewPost.vue"
export default component.exports